import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { useIdentity } from '@bonusly/who-am-i';

const headers = { 'Key-Inflection': 'camel' };

export const bizyMemberEnrollmentPath = (prefix = '') => `${prefix}bizy/member_enrollment`;

/**
 * Removes Bizy access for the authenticated user. Re-enrollment is an
 * administrator action, so this intentionally exposes no enable mutation.
 */
export const useDisableBizyForCurrentUser = () => {
	const http = useHttpClient('v2');
	const { refetchProfile } = useIdentity();

	return useMutation({
		mutationFn: async () => {
			const response = await http.delete(bizyMemberEnrollmentPath(), { headers });
			return response.data as { enabled: false };
		},
		onSuccess: () => {
			// Access removal has already succeeded. A profile refresh is best-effort
			// UI synchronization and must not turn that successful mutation into an
			// error if the identity endpoint is temporarily unavailable.
			void Promise.resolve(refetchProfile()).catch(() => {});
		},
	});
};
